import { motion } from "framer-motion";
import { Building2, Factory, Users, Handshake } from "lucide-react";

const Benifit = () => {
  const beneficiaires = [
    {
      title: "Entreprises Artisanales",
      icon: <Building2 className="w-8 h-8" />,
      image: "/images/entr-artisanal.webp",
      description: `Le projet Mobilier National est une initiative dédiée à la promotion et à la valorisation du savoir-faire artisanal local.
      Il soutient les entreprises artisanales dans la création de mobilier destiné à un usage public ou institutionnel.
      Ce projet offre aux artisans sélectionnés une occasion unique de participer à la conception et à la fabrication de pièces
      qui mettent en avant la richesse culturelle et l'expertise traditionnelle de leur région. En plus de cette visibilité, 
      les artisans bénéficient d'un accompagnement technique et d'un accès privilégié à de nouveaux marchés, tout en jouant 
      un rôle essentiel dans la préservation du patrimoine artisanal.`
    },
    {
      title: "Unités de Production Artisanales",
      icon: <Factory className="w-8 h-8" />,
      image: "/images/production.webp",
      description: `Les unités de production artisanales, également connues sous le nom d'ateliers traditionnels, sont des espaces 
      où des artisans experts créent des produits en utilisant des techniques et un savoir-faire transmis de génération 
      en génération. Ces ateliers, généralement de petite taille, se spécialisent dans la fabrication d'objets uniques ou 
      de petites séries, en mettant un point d'honneur sur la qualité et l'authenticité. Les produits issus 
      de ces unités incarnent souvent la culture locale et sont conçus avec des matériaux traditionnels, tout en respectant
      les méthodes artisanales établies. Ces ateliers jouent un rôle crucial dans la préservation du patrimoine culturel et
      artisanal, tout en contribuant activement au développement économique.`
    },
    {
      title: "Organisations Professionnelles Artisanales (OPA)",
      icon: <Users className="w-8 h-8" />,
      image: "/images/professionnelle.webp",
      description: `Une Organisation Professionnelle Artisanale (OPA) regroupe des artisans pour défendre leurs intérêts, valoriser leur 
      savoir-faire et soutenir leur développement. Ces organisations sont cruciales pour représenter les artisans auprès 
      des autorités, offrir des formations, faciliter l'accès aux ressources et créer des réseaux de collaboration. 
      Elles jouent un rôle clé dans la structuration du secteur en garantissant le respect des normes de qualité et 
      en améliorant les conditions de travail.`
    },
    {
      title: "Associations Artisanales à Caractère Économique",
      icon: <Handshake className="w-8 h-8" />,
      image: "/images/regroupement.webp",
      description: `Les associations artisanales à caractère économique regroupent des artisans pour mutualiser les ressources, renforcer 
      leur compétitivité et améliorer leurs conditions économiques. Elles facilitent l'accès à des marchés plus larges, négocient
      de meilleures conditions d'achat et partagent outils et espaces de production. En favorisant la formation, 
      l'échange de savoir-faire et des stratégies communes, elles contribuent à la croissance locale tout en préservant 
      l'artisanat traditionnel.`
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <section className="relative py-24 bg-[#1E3D1A]">
        <div className="absolute inset-0 bg-[url('/beneficiaire-pmn4.webp')] opacity-50" />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-8 tracking-wider">
              BÉNÉFICIAIRES DU PMN
            </h1>
            <p className="text-xl text-white/90">
              Découvrez les différents bénéficiaires soutenus par le Projet Mobilier National
            </p>
          </motion.div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {beneficiaires.map((beneficiaire, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <div className="relative h-64">
                  <img
                    src={beneficiaire.image}
                    alt={beneficiaire.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  <div className="absolute bottom-4 left-4 flex items-center space-x-2">
                    <div className="bg-[#1E3D1A] p-2 rounded-lg text-white">
                      {beneficiaire.icon}
                    </div>
                    <h3 className="text-xl font-bold text-white">
                      {beneficiaire.title}
                    </h3>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-gray-600 leading-relaxed text-justify">
                    {beneficiaire.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Benifit;
